module.exports = __webpack_public_path__ + "static/media/campus.55e4b771.svg";